var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBolaAzul(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 642,
    height: 1174,
    viewBox: "0 0 642 1174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M989 -33.3653C886.635 -108.924 762.223 -153 628.361 -153C280.322 -153 -4.50003e-05 144.512 -2.89681e-05 511.287C-1.29359e-05 878.062 280.322 1174 628.362 1174C762.223 1174 886.635 1129.92 989 1054.37L989 -33.3653Z",
    fill: "url(#paint0_linear_3_1302)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_1302",
    x1: 2074.49,
    y1: 241.254,
    x2: 539.199,
    y2: 1591.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3380A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90B9E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolaAzul);
export default __webpack_public_path__ + "static/media/bola-azul.32bc15083373abf70f811a000aa0c617.svg";
export { ForwardRef as ReactComponent };